import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Container, TextStyle, Text, Sprite } from "pixi.js";
import { UnboardingResourcePackage } from "../../resources/UnboardingResourcePackage";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";

export class UnboardingAvatarsContainer extends Container {

    public constructor(unboardingResources: UnboardingResourcePackage, commonResources: CommonResourcesPackage) {
        super();
        const rewardsText = new Text(`RENTER REWARDS WILL BE SHARED`, new ContainerTextStyle());
        rewardsText.style.fontSize = 51;
        rewardsText.angle = -5;
        rewardsText.skew.x = -0.08;
        this.addChild(rewardsText);
        const rewardsAdditionalText = new Text(`WITH BUILDING'S`, new ContainerTextStyle());
        rewardsAdditionalText.style.fontSize = 36;
        rewardsAdditionalText.angle = -5;
        rewardsAdditionalText.skew.x = -0.08;
        rewardsAdditionalText.position.set(0, 48);
        this.addChild(rewardsAdditionalText);
        const landlordText = new Sprite(unboardingResources.assets_views_unboarding_landlord_text_png);
        landlordText.position.set(-9, 67);
        this.addChild(landlordText);
        const wonText = new Text(`YOU WON`, new ContainerTextStyle());
        wonText.style.fontSize = 54;
        wonText.angle = -5;
        wonText.skew.x = -0.08;
        wonText.position.set(360, 85);
        this.addChild(wonText);
        const ownerAvatar = new Sprite(unboardingResources.assets_views_unboarding_owner_profile_icon_png);
        ownerAvatar.position.set(30, 142);
        this.addChild(ownerAvatar);
        const ownerTokenText = new Text(`0.006`, new ContainerTextStyle());
        ownerTokenText.style.fontSize = 35.81;
        ownerTokenText.position.set(32, 277);
        this.addChild(ownerTokenText);
        const ownerTokenIcon = new Sprite(commonResources.assets_common_ui_button_token_icon_png);
        ownerTokenIcon.width = 50;
        ownerTokenIcon.height = 50;
        ownerTokenIcon.position.set(107, 268);
        this.addChild(ownerTokenIcon);
        const renterAvatar = new Sprite(unboardingResources.assets_views_unboarding_renter_profile_icon_png);
        renterAvatar.position.set(374, 140);
        this.addChild(renterAvatar);
        const renterTokenText = new Text(`0.004`, new ContainerTextStyle());
        renterTokenText.style.fontSize = 35.81;
        renterTokenText.position.set(375.5, 277);
        this.addChild(renterTokenText);
        const renterTokenIcon = new Sprite(commonResources.assets_common_ui_button_token_icon_png);
        renterTokenIcon.width = 50;
        renterTokenIcon.height = 50;
        renterTokenIcon.position.set(449, 268);
        this.addChild(renterTokenIcon);
        const tokenWithSeparator = new Sprite(unboardingResources.assets_views_unboarding_token_with_separation_png);
        tokenWithSeparator.position.set(34, -41);
        this.addChild(tokenWithSeparator);
    }
}

class ContainerTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 72,
            fill: 'ffffff'
        });
    }
}